<script setup>
</script>
<template>
  <div class="px-[16px] py-[16px] rounded-md bg-purple-900 text-white">
    <slot />
  </div>
</template>
